import { render, staticRenderFns } from "./index.vue?vue&type=template&id=ed9511ba&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=ed9511ba&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed9511ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zhenzhaopin\\xxh-zhaopin-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ed9511ba')) {
      api.createRecord('ed9511ba', component.options)
    } else {
      api.reload('ed9511ba', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=ed9511ba&scoped=true", function () {
      api.rerender('ed9511ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/siteRichText/index.vue"
export default component.exports